import { Question } from './Question';

export class MultipleChoiceQuestion extends Question {
  isMultiSelect: true;
}
